import { PageShell } from "~/components/layout/page-shell";
import { Skeleton } from "~/components/ui/skeleton";

/** Keep profile geometry visible while its lazy code loads; no data imports. */
export function UserProfilePagePending() {
  return (
    <PageShell className="bg-background" contentClassName="gap-5" size="wide">
      <PageShell.Header>
        <div className="flex items-center gap-3">
          <Skeleton className="size-12 rounded-full" />
          <Skeleton className="h-7 w-40" />
        </div>
      </PageShell.Header>
      <PageShell.Main>
        <Skeleton className="h-80 w-full rounded-lg" />
        <Skeleton className="h-48 w-full rounded-lg" />
      </PageShell.Main>
      <PageShell.Rail className="hidden lg:block" width="lg">
        <Skeleton className="h-20 w-full rounded-lg" />
      </PageShell.Rail>
    </PageShell>
  );
}
